/**
Author - Sahil Dhingra
Git - https://github.com/sahildhingra-221
**/

import AddFaq from "./AddFaq";
import EditFaq from "./EditFaq";
import Search from "./Search";

export {
  AddFaq,
  EditFaq,
  Search
};
